import { useEffect } from 'react';
import { message } from 'antd';
import { useNotificationsStore } from '../../store/notifications';

export function NotificationContainer() {
  const notifications = useNotificationsStore((state) => state.notifications);
  const removeNotification = useNotificationsStore((state) => state.removeNotification);

  useEffect(() => {
    // Display latest notification using Ant Design message
    if (notifications.length > 0) {
      const latest = notifications[notifications.length - 1];

      const content = latest.message
        ? `${latest.title}: ${latest.message}`
        : latest.title;

      switch (latest.type) {
        case 'success':
          message.success(content);
          break;
        case 'error':
          message.error(content);
          break;
        case 'warning':
          message.warning(content);
          break;
        case 'info':
          message.info(content);
          break;
      }

      // Remove from store after displaying
      setTimeout(() => {
        removeNotification(latest.id);
      }, 100);
    }
  }, [notifications, removeNotification]);

  // This component doesn't render anything
  return null;
}
